import { render, staticRenderFns } from "./youxiang.vue?vue&type=template&id=f2cdbb94&scoped=true&"
import script from "./youxiang.vue?vue&type=script&lang=js&"
export * from "./youxiang.vue?vue&type=script&lang=js&"
import style0 from "./youxiang.vue?vue&type=style&index=0&id=f2cdbb94&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2cdbb94",
  null
  
)

export default component.exports